/**
 * Wrap Zod `safeParse` as `Result` for zw-cloud `/v1` JSON DTOs.
 *
 * Do not use this for project/on-disk JSON that arrived via `invoke`
 * (Rust serde owns that edge). See docs/fp-conventions.md.
 */

import type { ZodType } from "zod";
import { err, ok, type Result } from "../result";

export function decodeWithSchema<T>(
  schema: ZodType<T>,
  raw: unknown,
  label: string,
): Result<T, string> {
  const parsed = schema.safeParse(raw);
  if (parsed.success === true) return ok(parsed.data);

  const first = parsed.error.issues[0];
  if (typeof first === "undefined") return err(`${label}: invalid`);
  const path =
    first.path.length > 0 ? ` at ${first.path.map(String).join(".")}` : "";
  return err(`${label}${path}: ${first.message}`);
}
